// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__3wWuN","logo":"styles_logo__3gGPy","rotation":"styles_rotation__35quk","spin":"styles_spin__5xy6Y"};